module.exports = __webpack_public_path__ + "images/petal1.6266ff25.webp";